// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Util$SmartcutsMacros = require("../../../bs-utils/src/Util.bs.js");
var ExtErrors$SmartcutsMacros = require("../ExtErrors.bs.js");
var DOM__Element$SmartcutsMacros = require("../DOM__Element.bs.js");

function findInDomAndApplySemanticError_encode(error) {
  return ExtErrors$SmartcutsMacros.t_encode(undefined, (function (prim) {
                return prim;
              }), error);
}

function findInDomAndApplySemanticError_decode(json) {
  var error = ExtErrors$SmartcutsMacros.t_decode(undefined, Decco.stringFromJson, json);
  if (error.TAG !== /* Ok */0) {
    return {
            TAG: /* Error */1,
            _0: error._0
          };
  }
  var error$1 = error._0;
  if (typeof error$1 === "number") {
    switch (error$1) {
      case /* CdpUnableToGetContentQuads */0 :
      case /* CdpUnableToGetDocument */1 :
          return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected");
      default:
        return {
                TAG: /* Ok */0,
                _0: error$1
              };
    }
  } else {
    switch (error$1.TAG | 0) {
      case /* CdpQuerySelectorTimedOut */10 :
      case /* ErrorWhileCdpQuerySelector */11 :
      case /* PlaybackCaptureScreenshotError */12 :
      case /* ContentScriptResponseError */13 :
      case /* UnhandledContentScriptPromiseError */14 :
          return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected");
      default:
        return {
                TAG: /* Ok */0,
                _0: error$1
              };
    }
  }
}

function fromInputSelectionOrCursorSemanticsError(error) {
  if (typeof error === "number") {
    return error;
  }
  if (error.TAG !== /* OverlayStillBlockingElementAfterMs */5) {
    return error;
  }
  var match = error._0;
  return {
          TAG: /* OverlayStillBlockingElementAfterMs */5,
          _0: {
            element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
            maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
            ms: match.ms
          }
        };
}

function fromSelectionOrCursorSemanticsError(error) {
  if (typeof error === "number") {
    return error;
  }
  if (error.TAG !== /* OverlayStillBlockingElementAfterMs */5) {
    return error;
  }
  var match = error._0;
  return {
          TAG: /* OverlayStillBlockingElementAfterMs */5,
          _0: {
            element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
            maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
            ms: match.ms
          }
        };
}

function fromStrictSelectionSemanticsError(error) {
  if (typeof error === "number") {
    return error;
  }
  if (error.TAG !== /* OverlayStillBlockingElementAfterMs */5) {
    return error;
  }
  var match = error._0;
  return {
          TAG: /* OverlayStillBlockingElementAfterMs */5,
          _0: {
            element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
            maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
            ms: match.ms
          }
        };
}

function fromCursorSemanticsError(error) {
  if (typeof error === "number") {
    return error;
  }
  if (error.TAG !== /* OverlayStillBlockingElementAfterMs */5) {
    return error;
  }
  var match = error._0;
  return {
          TAG: /* OverlayStillBlockingElementAfterMs */5,
          _0: {
            element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
            maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
            ms: match.ms
          }
        };
}

function fromContentEditableCursorSemanticsError(error) {
  if (typeof error === "number") {
    return error;
  }
  if (error.TAG !== /* OverlayStillBlockingElementAfterMs */5) {
    return error;
  }
  var match = error._0;
  return {
          TAG: /* OverlayStillBlockingElementAfterMs */5,
          _0: {
            element: DOM__Element$SmartcutsMacros.getPathTo(match.element),
            maybeOverlayElement: Belt_Option.map(match.maybeOverlayElement, DOM__Element$SmartcutsMacros.getPathTo),
            ms: match.ms
          }
        };
}

var StrictSelectionSemantics;

var InputCursorSemantics;

var InputSelectionSemantics;

var InputSelectionOrCursorSemantics;

var ContentEditableCursorSemantics;

var ContentEditableSelectionSemantics;

var ContentEditableSelectionOrCursorSemantics;

exports.StrictSelectionSemantics = StrictSelectionSemantics;
exports.InputCursorSemantics = InputCursorSemantics;
exports.InputSelectionSemantics = InputSelectionSemantics;
exports.InputSelectionOrCursorSemantics = InputSelectionOrCursorSemantics;
exports.ContentEditableCursorSemantics = ContentEditableCursorSemantics;
exports.ContentEditableSelectionSemantics = ContentEditableSelectionSemantics;
exports.ContentEditableSelectionOrCursorSemantics = ContentEditableSelectionOrCursorSemantics;
exports.findInDomAndApplySemanticError_encode = findInDomAndApplySemanticError_encode;
exports.findInDomAndApplySemanticError_decode = findInDomAndApplySemanticError_decode;
exports.fromInputSelectionOrCursorSemanticsError = fromInputSelectionOrCursorSemanticsError;
exports.fromSelectionOrCursorSemanticsError = fromSelectionOrCursorSemanticsError;
exports.fromStrictSelectionSemanticsError = fromStrictSelectionSemanticsError;
exports.fromCursorSemanticsError = fromCursorSemanticsError;
exports.fromContentEditableCursorSemanticsError = fromContentEditableCursorSemanticsError;
/* Util-SmartcutsMacros Not a pure module */
